import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte, BokkzAlgDataService, Herinvesteringsreserve, IncomeTaxEntity,
    JaarrekeningBalans,
    OmschrijvingEnBedrag,
    Onderneming
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule, DecimalPipe } from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-spec-hir-ib',
    templateUrl: './spec-hir.component.html',
    imports: [
        SharedUiAlertModule,
        SharedUiDialogModule,
        SharedUiButtonModule,
        ReactiveFormsModule,
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        DecimalPipe,
        CommonModule
    ],
    styleUrls: ['./spec-hir.component.scss']
})
export class SpecHirComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);

    public showSpinner = true;
    public focusedElementId: string | null = null;
    public dialogVisible = false;

    public ondernemingFG: FormGroup;
    public specBeginstandHIRFG = {} as FormGroup;
    public specificatieHerinvesteringsreserveFG = {} as FormGroup;
    public formStructure: any;
    public ondernemingLength: any;
    public year = 2024;
    public jaren: SelectFormControlItem<number>[] = [];

    showDialog() {
        this.dialogVisible = true;
    }

    constructor(private fb: FormBuilder,
                private router: Router,
                public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
        this.ondernemingFG = this.fb.group({
            ondernemingen: this.fb.array([])
        });
        this.specBeginstandHIRFG = this.fb.group<JaarrekeningBalans>({
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number
        });
        this.specificatieHerinvesteringsreserveFG = this.fb.group({
            specificatieHerinvesteringsreserve: this.fb.array<Herinvesteringsreserve>([])
        });

    }

    //onderneming
    get ondernemingen(): FormArray {
        return this.ondernemingFG.get('ondernemingen') as FormArray;
    }

    createOndernemingFormGroup(onderneming?: Onderneming) {
        return this.dataService.createOndernemingFormGroup(onderneming);
    }

    // specificatie HIR
    getSpecHIR(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('specificatieHerinvesteringsreserve') as FormArray;
    }

    addSpecHIR(index: number): void {
        const innerGroup = this.fb.group<Herinvesteringsreserve>({
            omschrijving: null as unknown as string,
            jaarVanVervreemding: null as unknown as number,
            boekwinst: null as unknown as number,
            afschrijvingspercentage: null as unknown as number,
            boekwaardeOpVervreemdingsmoment: null as unknown as number
        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('specificatieHerinvesteringsreserve') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteSpecHIR(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getSpecHIR(outerIndex);
        innerArray.removeAt(innerIndex);
        this.saveForm();
    }

    createSpecHIRFG(item?: Herinvesteringsreserve): FormGroup {
        return this.fb.group<Herinvesteringsreserve>({
            omschrijving: item ? item.omschrijving : null as unknown as string,
            jaarVanVervreemding: item ? item.jaarVanVervreemding : null as unknown as number,
            boekwinst: item ? item.boekwinst : null as unknown as number,
            afschrijvingspercentage: item ? item.afschrijvingspercentage : null as unknown as number,
            boekwaardeOpVervreemdingsmoment: item ? item.boekwaardeOpVervreemdingsmoment : null as unknown as number
        });
    }

    // specificatie beginstandHIR
    getBeginstandHIR(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('beginstandHIR') as FormArray;
    }

    addBeginstandHIR(index: number): void {
        const innerGroup = this.fb.group<OmschrijvingEnBedrag>({
            omschrijving: '',
            bedrag: undefined as unknown as number

        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('beginstandHIR') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteBeginstandHIR(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getBeginstandHIR(outerIndex);
        innerArray.removeAt(innerIndex);
        this.saveForm();
    }


    createBeginstandHIRFG(item?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group<OmschrijvingEnBedrag>({
            omschrijving: item ? item.omschrijving : null as unknown as string,
            bedrag: item ? item.bedrag : null as unknown as number
        });
    }

    getTotaal(): number {
        const start = this.specBeginstandHIRFG.get('waardeOpening')?.getRawValue() || 0;
        let dotatie = this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0].dotatieHIR || 0;
        let onttrekking = this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0].vrijvalHIR || 0;
        this.partner.subscribe((partner) => {
            if (partner) {
                dotatie = this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0].dotatieHIR || 0;
                onttrekking = this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0].vrijvalHIR || 0;
            }
        });
        const einde = this.specBeginstandHIRFG.get('waardeSlot')?.getRawValue() || 0;
        const result = start + dotatie - onttrekking - einde;
        return Math.abs(result);
    }

    ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.partner.subscribe((boolean) => {
                    this.partnerBoolean = boolean;
                    this.ondernemingFG.reset();
                    this.specBeginstandHIRFG.reset();
                    this.specificatieHerinvesteringsreserveFG.reset();
                    this.updateForm();
                });
                this.year =  incomeTaxEntity.aangifte.aangifteJaar;
                this.jaren = [
                    { value: this.year, label: (this.year).toString() },
                    { value: this.year - 1, label: (this.year - 1).toString() },
                    { value: this.year - 2, label: (this.year - 2).toString() },
                    { value: this.year - 3, label: (this.year - 3).toString() },
                    { value: this.year - 4, label: (this.year - 4).toString() },
                    { value: this.year - 5, label: (this.year - 5).toString() }
                ];
                this.ondernemingFG.valueChanges.subscribe(value => {
                    this.formStructure = value;
                });
                this.ondernemingen.valueChanges.subscribe(value => {
                    this.ondernemingLength = value;
                });
            }
        });

        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });
        this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.ondernemingFG.dirty || this.specBeginstandHIRFG.dirty;
    }

    private updateForm(): void {
        let ondernemingenLijst = this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
        this.partner.subscribe((partner) => {
            const onderneming = !partner ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
            if (onderneming) {
                const hir = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'herinvesteringsReserve') as JaarrekeningBalans;
                this.specBeginstandHIRFG.patchValue(hir);
            }
            if (partner) {
                ondernemingenLijst = this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
            }
        });
        const formArray = this.ondernemingFG.get('ondernemingen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
        while (formArray.length > ondernemingenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Update ondernemingen
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(ondernemingenLijst[i], { emitEvent: false });
            } else {
                const formGroup = this.createOndernemingFormGroup(ondernemingenLijst[i]);
                formArray.push(formGroup);
            }
        }

        // Update beginstandHIR - ALLEEN als de array leeg is of niet bestaat
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            const onderneming = ondernemingenLijst[i];
            const beginstandHIR = onderneming.beginstandHIR || [];
            const beginstandHIRFormArray = this.getBeginstandHIR(i);

            // ALLEEN initialiseren als de FormArray nog leeg is
            if (beginstandHIRFormArray.length === 0 && beginstandHIR.length > 0) {
                for (let k = 0; k < beginstandHIR.length; k++) {
                    const ker = this.createBeginstandHIRFG(beginstandHIR[k]);
                    beginstandHIRFormArray.push(ker);
                }
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.partner.subscribe((partner) => {
                if (!partner) {
                    this.incomeTaxEntity.aangifte = {
                        ...this.incomeTaxEntity.aangifte,
                        box1: {
                            winstUitOnderneming: {
                                ...this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming,
                                ondernemingen: this.ondernemingFG.getRawValue().ondernemingen
                            }
                        }
                    } as Aangifte;

                    this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
                } else {
                    this.incomeTaxEntity.aangifte = {
                        ...this.incomeTaxEntity.aangifte,
                        partnerAangifte: {
                            ...this.incomeTaxEntity.aangifte?.partnerAangifte,
                            box1: {
                                winstUitOnderneming: {
                                    ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming,
                                    ondernemingen: this.ondernemingFG.getRawValue().ondernemingen
                                }
                            }
                        }
                    } as Aangifte;
                    this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
                }
            });
        }, 0);
    }

    public heeftOndernemingen(): boolean {
        if (this.partnerBoolean) {
            return !!(this.incomeTaxEntity &&
                this.incomeTaxEntity.aangifte?.partnerAangifte &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1 &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen &&
                this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        } else {
            return !!(this.incomeTaxEntity.aangifte &&
                this.incomeTaxEntity.aangifte?.box1 &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen &&
                this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen.length > 0);
        }
    }

    isSpecificatieHIRNotEmpty(index: number): boolean {
        const onderneming = this.ondernemingen.at(index) as FormGroup;
        const specificatieHIR = onderneming.get('specificatieHerinvesteringsreserve') as FormArray;
        return specificatieHIR && specificatieHIR.length > 0;
    }

    getTotaalBedragBeginVolgensSpec(): number {
        let totaal = 0;
        const ondernemingenArray = this.ondernemingFG.get('ondernemingen') as FormArray;

        ondernemingenArray.controls.forEach((ondernemingControl: AbstractControl) => {
            const beginstandHIRArray = (ondernemingControl.get('beginstandHIR') as FormArray).controls;

            beginstandHIRArray.forEach((hirControl: AbstractControl) => {
                const bedrag = hirControl.get('bedrag')?.getRawValue() || 0;
                totaal += bedrag;
            });
        });

        return totaal;
    }

    getTotaalBoekwinst(): number {
        let totaal = 0;
        const ondernemingen = this.ondernemingFG.get('ondernemingen') as FormArray;

        ondernemingen.controls.forEach((onderneming) => {
            const specHIR = onderneming.get('specificatieHerinvesteringsreserve') as FormArray;
            specHIR.controls.forEach((item) => {
                const boekwinst = item.get('boekwinst')?.getRawValue() || 0;
                totaal += boekwinst;
            });
        });

        return totaal;
    }

}
